'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:pay:getFingerprint');
}

var _invoke = require('../invoke');
var env = require('../invoke/env');
var versionCompare = require('../invoke/version-compare');

/**
 * 调用客户端收银台
 *
 * 支持版本
 * + iHotel/6.1+
 *
 * @memberof pay
 * @static
 * @name getFingerprint
 * @returns {Promise<String>}
 * @example
 *  hbnb.pay.getFingerprint()
 *      .then(function(fp) {
 *          fp = 'xxxxxxx'
 *      });
 */

module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('called');
    }
    var p = new Promise(function(resolve, reject) {
        if (versionCompare(env.appVersion, '6.1') >= 0) {
            _invoke('pay', 'get_fingerprint', {
                callback: function(fingerprint) {
                    if (process.env.NODE_ENV !== 'production') {
                        debug('fingerprint return %j', fingerprint);
                    }
                    if (fingerprint && fingerprint.fingerprint) {
                        resolve(fingerprint.fingerprint);
                    } else {
                        reject();
                    }
                }
            });
        } else {
            reject();
        }
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/pay/get-fingerprint.js
// module id = 384
// module chunks = 1 12 14